import { render, staticRenderFns } from "./AlumnoCorreoExitoso.vue?vue&type=template&id=e712f3ac"
import script from "./AlumnoCorreoExitoso.vue?vue&type=script&lang=js"
export * from "./AlumnoCorreoExitoso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports